import React, { Component } from 'react';
//import { Link } from 'react-router-dom';
import PropTypes from 'prop-types';
import Navigation from '../navigation/Navigation';

class Masthead extends Component {
  static propTypes = {
    user: PropTypes.string,
    roles: PropTypes.array.isRequired,
    onLogin: PropTypes.func.isRequired,
    onLogout: PropTypes.func.isRequired
  };

  onLogin = (username, password) => {
    this.props.onLogin(username, password);
  };

  onLogout = async () => {
    await this.props.onLogout();
  };

  render() {
    const { roles, user, location } = this.props;
    const avoidPath = location.pathname;
    var title = 'Competency Hub';
    var subHeading =
      'Browse competencies, career profiles and training resources to advance your career in the life sciences';
    // var subtextLink = true;

    if (avoidPath.includes('about')) {
      title = 'About the Competency Hub';
      subHeading =
        'Learn about competencies, career profiles and training resources';
      //  subtextLink = false;
    }

    if (avoidPath.includes('documentation')) {
      title = 'API documentation';
      subHeading =
        'Our API documenation is based on Open API specifications 2.0';
      // subtextLink = true;
    }

    if (avoidPath.includes('guidelines-course-creation')) {
      title = 'Guidelines for course creation';
      subHeading =
        'Learn how to use the Competency Hub to create effective courses';
      // subtextLink = false;
    }

    if (avoidPath.includes('privacy-notice')) {
      title = 'Data protection: Privacy notice for EMBL-EBI Competency Hub';
      subHeading =
        'Find out what personal data is collected by the EMBL-EBI Competency Hub and for what purposes, as well as how your data are processed and kept secure.';
      // subtextLink = false;
    }

    const bgStyle = {
      backgroundImage:
        'url(' +
        JSON.stringify(
          'https://acxngcvroo.cloudimg.io/v7/https://cms.competency.ebi.ac.uk/themes/custom/ebi_academy/images/mastheads/CH_Jigsaw.jpg'
        ) +
        ')',
      marginBottom: 0
    };

    return (
      <>
        {!avoidPath.includes('profile/view') &&
        !avoidPath.includes('profile/create') &&
        !avoidPath.includes('profiles/compare') &&
        !avoidPath.includes('profile/edit') &&
        !avoidPath.includes('profile/map') &&
        !avoidPath.includes('training-resources/') &&
        !avoidPath.includes('competency/details') &&
        !avoidPath.includes('framework') ? (
          <>
            <section className="vf-hero | vf-u-fullbleed" style={bgStyle}>
              <div className="vf-hero__content | vf-box | vf-stack vf-stack--400">
                <h1 className="vf-hero__heading">{title}</h1>
                <p className="vf-hero__subheading">{subHeading}</p>
              </div>
              {user && roles ? (
                <div
                  style={{
                    zIndex: 1000,
                    position: 'relative',
                    float: 'right',
                    padding: '10px',
                    margin: '10px',
                    top: '-22px'
                  }}
                >
                  <Navigation
                    roles={roles}
                    user={user}
                    onLogout={this.onLogout}
                  />
                </div>
              ) : (
                ''
              )}
            </section>
          </>
        ) : (
          ''
        )}
      </>
    );
  }
}

export default Masthead;
